const addProtocol = (url) => {
  const hasProtocol = /^https?:\/\//i.test(url);
  if (!hasProtocol) {
    return `http://${url}`;
  }
  return url;
};

export const textWithMarkdown = (text) => {
  const urlRegex =
    /(?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/gi;
  const parsedText = [];
  let lastIndex = 0;
  let match;

  const typescriptIsAnnoying = true;
  while (typescriptIsAnnoying) {
    match = urlRegex.exec(text);
    if (match === null) {
      break;
    }

    const url = match[0];
    const index = match.index;

    // Check if URL is part of Markdown link format
    const prevChar = text[index - 1];
    const nextChar = text[index + url.length];
    if (prevChar !== '(' || nextChar !== ')') {
      const linkText = text.slice(lastIndex, index);
      parsedText.push(linkText);
      parsedText.push(`[${url}](${addProtocol(url)})`);
      lastIndex = index + url.length;
    }
  }

  if (lastIndex < text.length) {
    parsedText.push(text.slice(lastIndex));
  }

  return parsedText.join('');
};

export function checkIfCursorOnUrl(text, cursorIndex) {
  // Early exit if text is empty or cursorIndex out of range
  if (
    !text ||
    text.length === 0 ||
    cursorIndex < 0 ||
    cursorIndex > text.length
  ) {
    return null;
  }

  // Define regex for a URL
  const urlPattern = /https?:\/\/[^\s]+/gi;

  // Define regex for a markdown URL
  const markdownUrlPattern = /\[(.*?)\]\((https?:\/\/[^\s]+)\)/gi;

  // Find all matches for URL and markdown URL
  const urlMatches = Array.from(text.matchAll(urlPattern));
  const markdownMatches = Array.from(text.matchAll(markdownUrlPattern));

  // Check if cursor is within any of the markdown URL matches
  for (const match of markdownMatches) {
    if (
      cursorIndex >= match.index &&
      cursorIndex < match.index + match[0].length
    ) {
      return {
        start: match.index,
        end: match.index + match[0].length,
        url: match[2],
        linkText: match[1],
        isMarkdown: true
      };
    }
  }

  // Check if cursor is within any of the URL matches
  for (const match of urlMatches) {
    if (
      cursorIndex >= match.index &&
      cursorIndex < match.index + match[0].length
    ) {
      // Exclude URLs which are part of markdown links
      if (
        !markdownMatches.some(
          (markdownMatch) => markdownMatch.index === match.index
        )
      ) {
        return {
          start: match.index,
          end: match.index + match[0].length,
          url: match[0],
          isMarkdown: false
        };
      }
    }
  }

  return null;
}
